import { render } from "./item-notification.vue?vue&type=template&id=6b0e3752&scoped=true"
import script from "./item-notification.vue?vue&type=script&lang=js"
export * from "./item-notification.vue?vue&type=script&lang=js"

import "./item-notification.vue?vue&type=style&index=0&id=6b0e3752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0e3752"]])

export default __exports__